import baseGet from "./component-library347.mjs";
function get(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
export {
  get as default
};
